import { TextField } from "@mui/material"
import { NoValueNeeded } from "./no-value-needed"
import { ConditionValueClassification } from "./condition-value-classification"
import { ConditionValueTrade } from "./condition-value-trade"
import { ConditionValueSkill } from "./condition-value-skill"
import { ConditionValueFrequency } from "./condition-value-frequency"
import { ConditionValueScheduleCode } from "./condition-value-schedule-code"
import { ConditionValueNumeric } from "./condition-value-numeric"
import { ConditionValueText } from "./condition-value-text"
import { ConditionValueUnitOfMeasure } from "./condition-value-unit-of-measure"
import { ConditionValueFrequencyPeriod } from "./condition-value-frequency-period"
import { ConditionValueScheduleType } from "./condition-value-schedule-type"
import { ConditionValueScheduleLibraryFolder } from "./condition-value-schedule-library-folder"
import { ConditionValueScheduleTags } from "./condition-value-schedule-tags"
import { ConditionValueCompliancePicker } from "./condition-value-compliance-picker"
import { ConditionValueComplianceType } from "./condition-value-compliance-type"
import { ConditionValueCodePicker } from "./condition-value-code-picker"
import { ConditionValueRegimeOptions } from "./condition-value-regime-options"
import { ConditionValueRegimeField } from "./condition-value-regime-field"
import { ConditionValueAssetField } from "./condition-value-asset-field"

export function ConditionValueInput({ fieldConfig, value, onChange, operator }) {
    if (!fieldConfig) return <TextField disabled fullWidth placeholder="Select a field to choose a value..." />

    const ValueComponent = fieldConfig.component
    if (ValueComponent) return <ValueComponent value={value} onChange={onChange} operator={operator} />

    switch (fieldConfig.valueComponent) {
        case "classification":
            return <ConditionValueClassification value={value} onChange={onChange} />
        case "trade":
            return <ConditionValueTrade value={value} onChange={onChange} />
        case "skill":
            return <ConditionValueSkill value={value} onChange={onChange} />
        case "frequency":
            return <ConditionValueFrequency value={value} onChange={onChange} />
        case "scheduleCode":
            return <ConditionValueScheduleCode value={value} onChange={onChange} />
        case "numeric":
            return <ConditionValueNumeric value={value} onChange={onChange} operator={operator} />
        case "text":
            return <ConditionValueText value={value} onChange={onChange} operator={operator} />
        case "unitOfMeasure":
            return <ConditionValueUnitOfMeasure value={value} onChange={onChange} />
        case "frequencyPeriod":
            return <ConditionValueFrequencyPeriod value={value} onChange={onChange} />
        case "scheduleType":
            return <ConditionValueScheduleType value={value} onChange={onChange} />
        case "scheduleLibraryFolder":
            return <ConditionValueScheduleLibraryFolder value={value} onChange={onChange} />
        case "scheduleTags":
            return <ConditionValueScheduleTags value={value} onChange={onChange} />
        case "compliancePicker":
            return <ConditionValueCompliancePicker value={value} onChange={onChange} />
        case "complianceType":
            return <ConditionValueComplianceType value={value} onChange={onChange} />
        case "codePicker":
            return <ConditionValueCodePicker value={value} onChange={onChange} operator={operator} />
        case "regimeOptions":
            return <ConditionValueRegimeOptions value={value} onChange={onChange} fieldConfig={fieldConfig} />
        case "regimeField":
            return <ConditionValueRegimeField value={value} onChange={onChange} />
        case "assetField":
            return <ConditionValueAssetField value={value} onChange={onChange} />
        case "optionality":
        case "retired":
        case "hasCompliance":
            return <NoValueNeeded operator={operator} />
        default:
            return <TextField disabled fullWidth />
    }
}
